<template>
  <section class="d-flex flex-column h-full">
    <!-- <div class="fixed-header w-full"> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      staticMode="true"
    ></TopAppBar>
    <TopAppBarDrawer
      :isDrawerOpen="isDrawerOpen"
      @closeDrawer="closeDrawer"
    ></TopAppBarDrawer>

    <div class="flex-grow-1 scroll-y">
    <RewardBadgeList></RewardBadgeList>
    <transition name="fade" mode="out-in">
        <router-view></router-view>
    </transition>    
    </div>

    
  </section>
</template>

<script>
/**
 * 나의 학습 메인 컴포넌트(my learn main component)
 *
 * @author minkyoung.park@emcast.com
 */

import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import RewardBadgeList from '@/components/reward/BadgeList'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

export default {
    name: 'Reward',

    data() {
        return {
            isDrawerOpen: false,
        }
    },
    
    components: {
        TopAppBar,
        RewardBadgeList,
        TopAppBarDrawer,
    },

    mixins: [topAppBarMixin],

    mounted() {
        this.leftBtnMode = "menu";
        this.leftBtnMethod = this.openDrawer;
    },
    
    methods: {
        openDrawer() {
          this.isDrawerOpen = true;
        },

        closeDrawer() {
           this.isDrawerOpen = false;
        },
    },
}

</script>
